module.exports = __webpack_public_path__ + "img/bmg66.89f4603a.png";